import API_URLS from '../config/apiConfig';
import { apiGet, apiPost } from '../utils/apiUtils';
import type { DailyExpandedAuditReport, ExpandedAuditReport, StoreAuditReportsResponse } from '../types/services/storeAuditReports';

export type {
  AuditReport,
  AuditSummary,
  AuditTotals,
  DailyAuditSummary,
  DailyExpandedAuditReport,
  DailyTotals,
  ExpandedAuditReport,
  Game,
  GameAuditTotals,
  GamePack,
  GamePosTotals,
  GameReconciliationVariance,
  LottoSummary,
  PosSummary,
  ReconciliationVariance,
  StoreAuditReportsResponse,
} from '../types/services/storeAuditReports';

export async function getStoreAuditReportsDateRange(
  storeId: string,
  startDate: string,
  endDate: string
): Promise<StoreAuditReportsResponse> {
  const params = new URLSearchParams({
    store_id: storeId,
    start_date: startDate,
    end_date: endDate,
  });
  const url = `${API_URLS.GET_STORE_AUDIT_REPORTS_DATE_RANGE}?${params.toString()}`;
  return apiGet(url);
}

export async function sendStoreReconciliationEmail(
  storeId: string,
  date: string,
  forceResend = false
): Promise<void> {
  const params = new URLSearchParams({
    date,
    force_resend: String(forceResend),
  });
  const url = `${API_URLS.SEND_STORE_RECONCILIATION_EMAIL(storeId)}?${params.toString()}`;
  await apiPost(url);
}

export async function getAuditReportExpanded(
  storeId: string,
  auditId: string
): Promise<ExpandedAuditReport> {
  const url = API_URLS.GET_AUDIT_REPORT_EXPANDED(storeId, auditId);
  return apiGet(url);
}

export async function getDailyAuditReportExpanded(
  storeId: string,
  reportDate: string
): Promise<DailyExpandedAuditReport> {
  const params = new URLSearchParams({
    store_id: storeId,
    report_date: reportDate,
  });
  const url = `${API_URLS.GET_STORE_AUDIT_REPORTS_DAILY_EXPANDED}?${params.toString()}`;
  return apiGet(url);
}
